import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AiPrompt} from "../../../../Model/aiprompt";
import {Product} from "../../../../Model/Catalog/Product";
import {LoginService} from "../../../../Services/login.service";
import {AiPromptsService} from "../../../../Services/aiprompt.service";
import {SystemService} from "../../../../Services/system.service";
import {TemplateService} from "../../../../Services/template.service";
import {InvoiceService} from "../../../../Services/invoice.service";

@Component({
    selector: 'np-product-description-wizard',
    templateUrl: './product-description-wizard.component.html',
    standalone: false
})
export class ProductDescriptionWizardComponent {
  @Input() model: Product;
  @Output() modelChange = new EventEmitter<Product>();

  prompt: AiPrompt;
  field: string;

  loading = false;
  promptResult;

  constructor(
    public loginService: LoginService,
    public promptService: AiPromptsService,
    public systemService: SystemService,
    public templateService: TemplateService,
    public invoiceServce: InvoiceService
  ) {
    this.confirmGenerate = this.confirmGenerate.bind(this);
    this.applyResult = this.applyResult.bind(this);
  }


  async confirmGenerate() {
    this.loading = true;
    try {
      const resp = await this.promptService.usePrompt(
        this.prompt,
        this.model.id,
        this.loginService.currentCustomer.id
      );

      this.promptResult = typeof resp === 'string' ? resp : resp?.result;
    } catch (err: any) {
      this.systemService.notifyWarning(
        err?.error?.message ?? err?.error?.detail ?? err?.message ?? 'Fehler beim Generieren.'
      );
    } finally {
      this.loading = false;
    }
  }

  async applyResult() {
    await this.promptService.applyPromptResult(
      this.promptResult,
      this.field,
      this.model.id,
      this.loginService.currentCustomer.id
    );
    this.modelChange.emit(this.model);
  }

}
